import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableGroupPosts = Loadable({
  loader: function loader() {
    return import('../GroupPosts.jsx');
  },
  loading: ComponentLoading
});
export default LoadableGroupPosts;